import { Home } from "./pages/Home";
import { Products } from "./pages/Products";
import { Checkout } from "./pages/Checkout";
import { ClearSale } from "./pages/Home/ClearSale";
import { ProductsCart } from "./pages/ProductsCart";
import { PrivateRoute } from "./common/PrivateRoute";
import { DefaultLayout } from "./layouts/DefaultLayout";
import { AuthenticateApp } from "./pages/AuthenticateApp";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { SuccessfulPurchase } from "./pages/SuccessfulPurchase";
import { PurchaseUnderReview } from "./pages/PurchaseUnderReview";
import { useEffect } from "react";

// Router for all web pages
export function Router() {
  useEffect(() => {
    document.title = process.env.REACT_APP_PRODUCT;
  }, []);

  return (
    <BrowserRouter basename={process.env.PUBLIC_URL}>
      <Routes>
        {/* Public routes */}
        <Route
          path="/"
          element={
            process.env.REACT_APP_PRODUCT === "ClearSale" ? (
              <ClearSale />
            ) : (
              <Home />
            )
          }
        />
        <Route path="/" element={<DefaultLayout />}>
          <Route path="/products" element={<Products />} />
          <Route path="/product-cart" element={<ProductsCart />} />
          <Route path="/authenticate-app" element={<AuthenticateApp />} />
          <Route path="/checkout" element={<Checkout />} />
          {/* Private routes */}
          <Route element={<PrivateRoute />}>
            <Route
              path="/successful-purchase"
              element={<SuccessfulPurchase />}
            />
            <Route
              path="/purchase-under-review"
              element={<PurchaseUnderReview />}
            />
          </Route>
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
